import Icon from 'components/ui/Icon';
import type { City } from 'types/Utilities';

type Props = {
  name: string;
  description: string;
  city?: City;
  styles: { readonly [key: string]: string };
};

const AuthorInfo = ({
  description,
  name,
  city,
  styles,
}: Props): JSX.Element => {
  return (
    <>
      <h6 className={styles.customRichH6}>{description}</h6>
      <h1 className={styles.title}>{name}</h1>
      {city && (
        <p className={styles.location}>
          <Icon type="LocationPinAlternate" color="#216679" />
          &nbsp; {city.name}, {city.country.name}
        </p>
      )}
    </>
  );
};

export default AuthorInfo;
